import { render } from "./activity-selector.component.vue?vue&type=template&id=509d6521&scoped=true&ts=true"
import script from "./activity-selector.component.vue?vue&type=script&lang=ts"
export * from "./activity-selector.component.vue?vue&type=script&lang=ts"

import "./activity-selector.component.vue?vue&type=style&index=0&id=509d6521&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509d6521"]])

export default __exports__